<template>
  <div>
    <v-row dense class="text-center align-center justify-center mt-2">
      <v-col cols="12" sm="12" md="12" lg="4">
        <v-card
          class="pa-2 rounded-card card-shadow"
          v-bind="$attrs"
        >
          <px-bar-chart theme="primary"
                        title="Total comprado (R$)"
                        user-currency-formatter
                        :truncate-x-label="5"
                        :loading="loading"
                        :categories="totalComprado.labels"
                        :values="totalComprado.values"
          />
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="4">
        <v-card
          class="pa-2 rounded-card card-shadow"
          v-bind="$attrs"
        >
          <px-bar-chart theme="secondary"
                        title="Quantidade de itens comprados"
                        left="35"
                        :truncate-x-label="5"
                        :loading="loading"
                        :categories="quantidadeProdutos.labels"
                        :values="quantidadeProdutos.values"
          />
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="4">
        <v-card
          class="pa-2 rounded-card card-shadow"
          v-bind="$attrs"
        >
          <px-bar-chart theme="primary"
                        title="Quantidade de compras realizadas"
                        left="35"
                        :truncate-x-label="5"
                        :loading="loading"
                        :categories="quantidadeCompras.labels"
                        :values="quantidadeCompras.values"
          />
        </v-card>
      </v-col>
    </v-row>
    <v-row dense class="text-center align-center justify-center mt-2">
      <v-col cols="12" sm="12" md="12" lg="4">
        <v-card
          class="pa-2 rounded-card card-shadow"
          v-bind="$attrs"
        >
          <px-bar-chart use-decimal-number
                        theme="secondary"
                        title="Média de itens por compra"
                        left="35"
                        :truncate-x-label="5"
                        :loading="loading"
                        :categories="mediaQuantidadeProdutos.labels"
                        :values="mediaQuantidadeProdutos.values"
          />
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="4">
        <v-card
          class="pa-2 rounded-card card-shadow"
          v-bind="$attrs"
        >
          <px-bar-chart use-decimal-number
                        theme="primary"
                        title="Prazo médio de pagamento"
                        left="35"
                        :truncate-x-label="5"
                        :loading="loading"
                        :categories="pmp.labels"
                        :values="pmp.values"
          />
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="4">
        <v-card
          class="pa-2 rounded-card card-shadow"
          v-bind="$attrs"
        >
          <px-bar-chart use-decimal-number
                        theme="secondary"
                        title="Prazo médio de entrega (dias)"
                        left="35"
                        :truncate-x-label="5"
                        :loading="loading"
                        :categories="prazoEntrega.labels"
                        :values="prazoEntrega.values"
          />
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BarChart from './FornecedorBarChart.vue';

export default {
  props: {
    loading: Boolean,
    fornecedores: Array,
  },
  computed: {
    totalComprado() {
      return this.mapField('total');
    },
    quantidadeProdutos() {
      return this.mapField('quantidadeProdutos');
    },
    quantidadeCompras() {
      return this.mapField('quantidadeCompras');
    },
    mediaQuantidadeProdutos() {
      return this.mapField('mediaQuantidadeProdutos');
    },
    prazoEntrega() {
      return this.mapField('prazoEntrega');
    },
    pmp() {
      return this.mapField('pmp');
    },
  },
  methods: {
    mapField(field) {
      if (!this.fornecedores) {
        return { labels: [], values: [] };
      }
      return {
        labels: this.fornecedores.map(f => f.nome),
        values: this.fornecedores.map(f => f[field]),
      };
    },
  },
  components: {
    pxBarChart: BarChart,
  },
};
</script>
